import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../Pages/Home/Home'
import Solutions from '../Pages/Solutions'
import Panels from '../Pages/Panels'

export default function Router() {
  return (
    <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/solutions' element={<Solutions/>}/>
      <Route path='/panels' element={<Panels/>}/>
    </Routes> 
  )
}
